import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import PopupWrapper from "../../components/PopupWrapper";
import CreateTicket from "../../components/CreateTicket/createTicket";
import axios from "../../axios";
import urls from "../../Utils/urls";
import CommonGrid from "../../components/CommonGrid";
import { LiHandleButton, SpinnerBlock } from "../../Utils/CustomComponent";
import { gridColumns_ticket } from "../../Utils/TableColumnDefs";
import TabComp from "../../components/CreateTicket/tabComponent";
import DaysOldComp from "../../components/CreateTicket/DaysOldComp";
import { Doughnut, Bar } from "react-chartjs-2";
import { calculateDaysOld } from "../../Utils/CustomComponent";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import Heading from "../../components/Heading";
import moment from "moment";
import { useSelector } from "react-redux";
import classes from "../ReportsNDocuments/reports.module.css";
import TicketTable from "./TicketTable";

const SupportManagement = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [allTickets, setAllTickets] = useState(null);
  const [refreshTable, setRefreshTable] = useState(false);
  const [tabsData, setTabsData] = useState(null);
  // const [barChartData, setBarChartData] = useState({});
  const [status, setStatus] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const today = new Date().toISOString().split("T")[0];

  const isToday = (createdDate) => {
    const todayFormatted = moment().format("MM/DD/YY");
    const ticketCreatedDate = moment(createdDate, "MM/DD/YY hh:mm A").format(
      "MM/DD/YY"
    );
    return todayFormatted === ticketCreatedDate;
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };
  const userId = localStorage.getItem("apex_userid");
  // useEffect(() => {
  //   if (allTickets) {
  //     const ticketsStatus = allTickets.filter((ticket) =>
  //       ticket.status_type.includes("Open")
  //     );
  //     const oneDayOld = ticketsStatus.filter(
  //       (ticket) => calculateDaysOld(ticket.created) <= 1
  //     );

  //     const twoDaysToOneWeek = ticketsStatus.filter(
  //       (ticket) =>
  //         calculateDaysOld(ticket.created) > 1 &&
  //         calculateDaysOld(ticket.created) <= 7
  //     );

  //     const overOneWeek = ticketsStatus.filter(
  //       (ticket) => calculateDaysOld(ticket.created) > 7
  //     );

  //     const newBarChartData = {
  //       labels: ["1 Day Old", "2 Days - 1 Week", "Over 1 week old"],
  //       datasets: [
  //         {
  //           data: [
  //             oneDayOld?.length,
  //             twoDaysToOneWeek?.length,
  //             overOneWeek?.length,
  //           ],
  //           backgroundColor: ["#36A2EB", "#FFCE56", "#FF6384"],
  //           borderColor: ["#36A2EB", "#FFCE56", "#FF6384"],
  //           borderWidth: 1,
  //         },
  //       ],
  //     };

  //     setBarChartData(newBarChartData);
  //   }
  // }, [allTickets]);
  // useEffect(() => {
  //   setStatus("loading");
  //   // axios
  //   //   .get(urls.support.getAllTickets(userId), {
  //   //     headers: {
  //   //       Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  //   //     },
  //   //   })
  //   axios
  //     .get(urls.support.getStatusTickets(userId, tabButtons?.[activeTab].key), {
  //       headers: {
  //         Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  //       },
  //     })
  //     .then((res) => {
  //       // setAllTickets(res.data.items);
  //       // setStatus("fulfilled");
  //       const newTabsData = [
  //         {
  //           length: res.data.items?.filter((ticket) => isToday(ticket.created))
  //             ?.length,
  //           ticketStatus: "Tickets Created Today",
  //           color: "#333",
  //         },
  //         {
  //           length: res.data.items?.filter((ticket) => ticket.assignee === null)
  //             ?.length,
  //           ticketStatus: "Unassigned Tickets",
  //           color: "#60a5fa",
  //         },
  //         {
  //           length: res.data.items?.filter((ticket) =>
  //             ticket.status_type.includes("Open")
  //           )?.length,
  //           ticketStatus: "Open Tickets",
  //           color: "#60a5fa",
  //         },
  //       ];
  //       setTabsData(newTabsData);
  //     });
  // }, [refreshTable, userId, activeTab]);

  const prepareChartData = () => {
    if (!allTickets) return null;

    const urgencyLevels = ["Low", "Medium", "High"];
    const data = urgencyLevels.map((level) => {
      const ticketsWithLevel = allTickets.filter(
        (ticket) =>
          ticket.status.includes("Open") && ticket.urgency_name === level
      );
      return ticketsWithLevel?.length;
    });
    return {
      labels: urgencyLevels,
      datasets: [
        {
          data,
          backgroundColor: ["#36A2EB", "#FFCE56", "#FF6384"],
        },
      ],
    };
  };
  const textCenter = {
    id: "textCenter",
    beforeDatasetDraw: function (chart) {
      var width = chart.width,
        height = chart.height,
        ctx = chart.ctx;

      ctx.restore();
      var fontSize = (height / 114).toFixed(2);
      ctx.font = fontSize - 1 + "rem sans-serif";
      ctx.textBaseline = "middle";
      const dataText = allTickets?.filter((ticket) =>
        ticket.status.includes("Open")
      );
      var text = `Total ${dataText?.length}`,
        textWidth = ctx.measureText(text).width,
        textX = (width - textWidth) / 2,
        textY = height / 2 + 24;

      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  };
  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="All Tickets" />,
      // role: ["Both"],
      className: "col-sm-6 px-4",
    },
    {
      component: (
        <Button
          className="text-white create-ticket"
          onClick={() => {
            setShowPopup(true);
          }}
        >
          {" "}
          Create Ticket
        </Button>
      ),
      // role: ["Both"],
      className: "col-sm-6 px-4 text-end",
    },
    {
      component: <TabComp tabsData={tabsData} />,
      // role: ["Both"],
      className: "col-sm-12 col-md-12 col-lg-8 pl-4 mb-5 mt-4",
    },
    {
      component: <DaysOldComp />,
      // role: ["Both"],
      className: "col-sm-12 col-md-12 col-lg-4 mb-5 mt-4",
    },
    {
      component: (
        <TicketTable
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          refreshTable={refreshTable}
          setTabsData={setTabsData}
        />
      ),
      // role: ["Both"],
      className: "col-sm-12 col-md-12 col-lg-12",
    },
    // {
    //   component: (
    //     <div
    //       className="w-100 h-100 col-sm-3 d-flex mt-sm-4 mt-lg-0"
    //       style={{ maxWidth: "100%", overflow: "hidden" }}
    //     >
    //       <div className="bg-white rounded flex-grow-1 w-100">
    //         <h4 className="p-4">Open Tickets: Severity Level</h4>
    //         <div
    //           className="p-4 mb-5"
    //           style={{ width: "290px", height: "290px", margin: "auto" }}
    //         >
    //           {allTickets ? (
    //             <Doughnut
    //               key={refreshTable}
    //               data={prepareChartData()}
    //               plugins={[textCenter]}
    //               options={{
    //                 cutout: "80%",
    //                 elements: {
    //                   arc: {
    //                     borderWidth: 0,
    //                     radius: "80%",
    //                   },
    //                 },
    //                 hover: {
    //                   mode: "nearest",
    //                   intersect: true,
    //                 },
    //                 hoverOffset: 5,
    //               }}
    //             />
    //           ) : (
    //             <SpinnerBlock />
    //           )}
    //         </div>
    //         <div className="mt-5 p-4 pt-5 me-4 d-flex flex-column justify-content-center align-content-end">
    //           <h4 className="p-4">Ticket Aging</h4>
    //           {barChartData.labels ? (
    //             <Bar
    //               key={refreshTable}
    //               data={barChartData}
    //               options={options}
    //               width={"450px"}
    //             />
    //           ) : (
    //             <SpinnerBlock />
    //           )}
    //         </div>
    //       </div>
    //     </div>
    //   ),
    //   // role: ["Both"],
    //   className: "col-sm-12 col-md-12 col-lg-3 mt-sm-4 mt-lg-0",
    // },
  ];

  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className="rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
          {showPopup && (
            <PopupWrapper
              title={
                <h2 className="p-4 font-weight-bold text-dark">
                  Create Ticket
                </h2>
              }
              extraClass={`${isLargeDevice ? "width-800" : ""}`}
              Component={
                <CreateTicket
                  close={() => setShowPopup(false)}
                  refreshTable={() => setRefreshTable(!refreshTable)}
                />
              }
              toShow={showPopup}
              closeEventHandler={() => {
                setShowPopup(false);
              }}
            />
          )}
        </article>
      </section>
    </div>
  );
};
export default SupportManagement;

const tabButtons = [
  { label: <p>Open</p>, title: "Open Tickets", key: "OPEN" },
  { label: <p>Closed</p>, title: "Closed Tickets", key: "CLOSED" },
];
